import { Component, inject, signal, WritableSignal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { take } from 'rxjs';
import { ApiService } from '../../../api/services/api.service';
import { NgClass } from '@angular/common';
import { environment } from '../../../../../../environments/environment';
import { CopyToClipboardCopiedDirective } from '../../directives/copy-to-clipboard-copied.directive';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-benefit-business-account',
  imports: [
    MatIcon,
    NgClass,
    CopyToClipboardCopiedDirective
  ],
  templateUrl: './benefit-business-account.component.html',
  styleUrl: './benefit-business-account.component.scss'
})
export class BenefitBusinessAccountComponent {
  private readonly _apiService: ApiService = inject(ApiService);
  private matSnackBar: MatSnackBar = inject(MatSnackBar);
  private translateService: TranslateService = inject(TranslateService);
  public readonly isLoadingRegistration: WritableSignal<boolean> = signal(false);
  public readonly linkWebVersion: WritableSignal<string> = signal(environment.linkWebVersion);
  public readonly authService: AuthService = inject(AuthService);

  sendRegistrationInstructions(): void {
    if (this.isLoadingRegistration()) {
      return; // Предотвращаем повторный вызов
    }
    
    this.isLoadingRegistration.set(true);
    this._apiService.sendRegistrationInstructions().pipe(take(1)).subscribe({
      next: () => {
        setTimeout(() => {
          this.isLoadingRegistration.set(false);
        }, 7000);
        const snackConfig: MatSnackBarConfig = {
          duration: 2000,
        }
        this.matSnackBar.open('Instructions have been sent in chat.', this.translateService.instant('common.buttons.close'), snackConfig)
      },
      error: () => {
        this.isLoadingRegistration.set(false);
      }
    });
  }
}
